// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"client-reports_routeHeader_3L2g3","iconSpace":"client-reports_iconSpace_ZbBuw","addButton":"client-reports_addButton_1fmk7","error":"client-reports_error_1Ubbr"};